<template>
  <div>
    <b-row class="content-header mb-2">
      <!-- Content Left -->
      <b-col class="content-header-left" cols="12" md="9">
        <breadcrumb :lastItemName="car.name" />
      </b-col>

      <!-- Content Right -->
      <b-col class="content-header-right text-md-right" md="3" cols="12">
        <b-button
          @click="showFormModal(null)"
          class="px-3 text-capitalize"
          variant="primary"
        >
          <feather-icon size="16" icon="PlusIcon" class="mr-50" />
          ایجاد تیکت
        </b-button>
      </b-col>
    </b-row>
    <div v-if="carDates">
      <div class="d-flex justify-content-between align-items-center">
        <per-page class="col-sm-12 col-md-3 col-lg-2" v-model="perPage" />
        <!-- <search
          ref="residencesSearchComponent"
          class="w-50"
          v-model="searchInput"
        /> -->
      </div>

      <b-table-simple responsive>
        <b-thead>
          <b-tr>
            <b-th>id</b-th>
            <b-th>عنوان</b-th>
            <b-th>ایام تیکت</b-th>
            <b-th>ظرفیت</b-th>
            <b-th>نوع تیکت</b-th>
            <b-th>هزینه</b-th>
            <b-th>کمسیون سایت</b-th>
            <b-th>تاریخ ایجاد</b-th>
            <b-th>وضعیت</b-th>
            <b-th>عملیات</b-th>
          </b-tr>
        </b-thead>
        <b-tbody>
          <b-tr v-for="item in carDates" :key="item.id">
            <b-td>{{ item.id }}</b-td>
            <b-td>{{ item.name }}</b-td>
            <b-td>
              <b-badge variant="success" class="badge-glow" v-for="(day,i) in item.recurring_period" style="margin: 4px">
                <span v-if="day==='Saturday'">
                  شنبه
                </span>
                <span v-if="day==='Sunday'">
                  یکشنبه
                </span>
                <span v-if="day==='Monday'">
                  دوشنبه
                </span>
                <span v-if="day==='Tuesday'">
                  سه شنبه
                </span>
                <span v-if="day==='Wednesday'">
                  چهارشنبه
                </span>
                <span v-if="day==='Thursday'">
                  پنج شنبه
                </span>
                <span v-if="day==='Friday'">
                  جمعه
                </span>
              </b-badge>
            </b-td>
            <b-td>{{item.max_people}} نفر</b-td>
            <b-td>
              <span v-if="item.price_type==='pricePerPerson'">
                به ازای هر فرد
              </span>
              <span v-else>
                به ازای هر وسیله نقلیه
              </span>

            </b-td>
            <b-td>{{ item.prices.normal_dayes }}</b-td>
            <b-td>
              <span v-if="item.commission_site">
                {{numberFormat(item.commission_site)}} به ازای هر فرد
              </span>
              <span v-if="item.commission_host">
                   {{numberFormat(item.commission_host)}}  میزبان
              </span>
            </b-td>

            <b-td>
              {{
                new Date(item.created_at).toLocaleString("fa-IR", {
                  timeZone: "Iran",
                })
              }}
            </b-td>
            <b-td>
              <b-col
                class="d-flex align-items-center pl-0"
                :class="
                  item.status != 'active' ? 'text-danger' : 'text-success'
                "
              >
                {{ item.status == "active" ? "" : "غیر" }}فعال
              </b-col></b-td
            >
            <b-td>
              <b-col class="d-flex align-items-center">
<!--                <b-button
                  @click="showConfirmModal(item)"
                  variant="flat-danger"
                  class="font-weight-bolder"
                >
                  <feather-icon icon="Trash2Icon" size="20" />
                </b-button>-->
                <b-button
                  @click="showFormModal(item)"
                  variant="flat-secondary"
                  class="font-weight-bolder"
                >
                  <feather-icon icon="Edit2Icon" size="20" />
                </b-button> </b-col
            ></b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>
      <pagination
        ref="residencesPaginationComponent"
        v-model="page"
        :paginationData="paginationData"
      />
    </div>
    <b-sidebar
      width="800px"
      v-model="formModal"
      right
      backdrop
      shadow
      bg-variant="white"
    >
      <template #header>
        <div class="w-100">
          <div class="text-right">
            <b-button
              style="background-color: rgba(75, 75, 75, 0.12)"
              @click="formModal = false"
              variant="flat-dark"
              class="btn-icon rounded-circle mr-1"
            >
              <feather-icon icon="XIcon" size="20" />
            </b-button>
          </div>
          <div class="mr-1 sidebarHeaderTitleDiv">
            <h3 class="text-capitalize">
              {{ editMode ? "ویرایش تیکت" : "ایجاد تیکت" }}
            </h3>
          </div>
        </div>
      </template>
      <b-container class="row">
        <b-form-group class="col-md-6">
          <label for="name" class="text-capitalize">
            عنوان تیکت : <span class="text-danger">*</span></label
          >
          <b-form-input
            @input="removeErrors('name')"
            id="name"
            v-model="ticketInput.name"
            type="text"
          />
          <ErrorMessage
            errorType="name"
            :errorMessages="errorMessage"
          ></ErrorMessage>
        </b-form-group>
        <b-form-group class="col-md-6">
          <label for="residence_area" class="text-capitalize">
            نوع اجرا :<span class="text-danger">*</span>
          </label>
          <v-select
            id="residence_area"
            :components="{ OpenIndicator }"
            class="bg-white"
            :clearable="false"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="['گروهی', 'نفری']"
            v-model="ticketInput.execution_type"
          />
        </b-form-group>

        <b-form-group class="col-md-6">
          <label for="residence_area" class="text-capitalize">
            جنسیت :<span class="text-danger">*</span>
          </label>
          <v-select
            id="residence_area"
            :components="{ OpenIndicator }"
            class="bg-white"
            :clearable="false"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="['آقا', 'هردو', 'خانم']"
            v-model="ticketInput.gender"
          />
        </b-form-group>
        <b-form-group class="col-md-6">
          <label for="residence_area" class="text-capitalize">
            نوع تیکت :<span class="text-danger">*</span>
          </label>
          <v-select
            id="residence_area"
            :components="{ OpenIndicator }"
            class="bg-white"
            :clearable="false"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="['vip', 'ارگانی', 'معمولی']"
            v-model="ticketInput.ticket_type"
          />
        </b-form-group>
        <b-col cols="12" class="mb-2">
<!--          {{ticketInput}}-->
          <b-form-group>
            <b-form-radio
                v-model="ticketInput.price_type"
                name="some-radios3"
                value="pricePerPerson"
            >قیمت به ازای هر فرد</b-form-radio
            >
            <b-form-radio
                v-model="ticketInput.price_type"
                name="some-radios3"
                value="pricePerCar"
            >قیمت به ازای هر وسیله نقلیه</b-form-radio
            >
          </b-form-group>
        </b-col>

        <b-form-group class="mt-1 col-md-12" v-if="ticketInput.price_type !== 'pricePerCar'">
          <label for="name" class="text-capitalize">  حداکثر ظرفیت نفرات : </label>
          <b-form-input v-model="ticketInput.max_people" type="number" />
        </b-form-group>

        <b-form-group class="mt-1 col-md-12"  v-if="ticketInput.price_type !== 'pricePerPerson'">
          <label for="name" class="text-capitalize">  حداکثر تعداد وسیله نقلیه  : </label>
          <b-form-input  v-model="ticketInput.max_people" type="number" />
        </b-form-group>

        <b-form-group class="mt-1 col-md-12" v-if="ticketInput.price_type !== 'pricePerPerson'">
          <label for="name" class="text-capitalize">  حداکثر ظرفیت نفرات در وسیله نقلیه : </label>
          <b-form-input v-model="ticketInput.max_capacity_people" type="number" />
        </b-form-group>



        <b-form-group class="mt-1 col-md-6">
          <label for="name" class="text-capitalize">
            شروع راس ساعت : <span class="text-danger">*</span></label
          >
<!--          <b-form-input
            v-model="ticketInput.start_time"
            locale="fa"
            :id="`type-${1}`"
            type="time"
          ></b-form-input>-->
          <date-picker v-model="ticketInput.start_time" type="time" />
        </b-form-group>
        <b-form-group class="mt-1 col-md-6">
          <label for="name" class="text-capitalize">
            پایان راس ساعت :<span class="text-danger">*</span>
          </label>
          <date-picker v-model="ticketInput.end_time" type="time" />
<!--          <b-form-input
            v-model="ticketInput.end_time"
            locale="fa"
            :id="`type-${2}`"
            type="time"
          ></b-form-input>-->
        </b-form-group>

        <b-form-group class="mt-1 col-md-12">
          <label for="name" class="text-capitalize">  مدت زمان اجرای هر تیکت  مثلا ( 10 دقیقه یا 2 ساعت واحد زمان ذکر گردد ) : </label>
          <b-form-input v-model="ticketInput.duration" type="text" />
        </b-form-group>


        <b-form-group class="mt-1 col-md-12" v-slot="{ ariaDescribedby }">
          <b-form-checkbox
            v-model="ticketInput.is_recurring_period"
            :aria-describedby="ariaDescribedby"
            value="1"
            @input="removeErrors('status')"
            >دوره تکرار شونده</b-form-checkbox
          >
        </b-form-group>
<!--        <b-form-group v-if="!ticketInput.is_recurring_period" class="col-md-6">
          <label for="name" class="text-capitalize"> روز شروع : </label>
          <b-form-input class="my-custom-editable-input1" type="text" />
          <date-picker
            auto-submit
            clearable
            format="YYYY-MM-DD"
            display-format="jYYYY-jMM-jDD"
            v-model="ticketInput.start_date"
            custom-input=".my-custom-editable-input1"
          />
        </b-form-group>
        <b-form-group v-if="!ticketInput.is_recurring_period" class="col-md-6">
          <label for="name" class="text-capitalize"> روز پایان : </label>
          <b-form-input class="my-custom-editable-input2" type="text" />
          <date-picker
            auto-submit
            clearable
            format="YYYY-MM-DD"
            display-format="jYYYY-jMM-jDD"
            v-model="ticketInput.return_date"
            custom-input=".my-custom-editable-input2"
          />
        </b-form-group>-->

        <b-form-group
          label="روزهای در دسترس"
          class="col-md-12 font-sm"
          v-slot="{ ariaDescribedby }"
          v-if="ticketInput.is_recurring_period"
        >
          <b-form-checkbox-group
            v-model="ticketInput.recurring_period"
            :options="dayOptions"
            :aria-describedby="ariaDescribedby"
            name="flavour-1a"
            class="font-sm"
          ></b-form-checkbox-group>
        </b-form-group>

        <label for="name" class="text-capitalize col-md-12 mt-2">
          هزینه ها :<span class="text-danger">*</span>
        </label>
        <b-form-group class="mt-1 col-md-6">
          <label for="name" class="text-capitalize"> ایام عادی : </label>
          <b-form-input :formatter="formatnumber" v-model="ticketInput.prices.normal_dayes" type="text" />
        </b-form-group>

        <b-form-group class="mt-1 col-md-6">
          <label for="name" class="text-capitalize"> ایام آخر هفته : </label>
          <b-form-input :formatter="formatnumber"  v-model="ticketInput.prices.weekend_days" type="text" />
        </b-form-group>

<!--        <b-form-group class="mt-1 col-md-6">
          <label for="name" class="text-capitalize"> ایام پیک : </label>
          <b-form-input :formatter="formatnumber" v-model="ticketInput.prices.peack_days" type="text" />
        </b-form-group>-->
        <b-form-group class="col-md-6">
          <b-form-checkbox
            :label="ticketInput.prices.pricePerBaby.name"
            v-model="ticketInput.prices.pricePerBaby.hasPrice"
          >
            هزینه به ازای هر نوزاد
          </b-form-checkbox>
          <b-form-input
            lazy
            :formatter="formatnumber"
            :disabled="!ticketInput.prices.pricePerBaby.hasPrice"
            v-model="ticketInput.prices.pricePerBaby.price"
          ></b-form-input>
        </b-form-group>
        <b-form-group class="col-md-6">
          <b-form-checkbox
            :label="ticketInput.prices.pricePerAnimal.name"
            v-model="ticketInput.prices.pricePerAnimal.hasPrice"
          >
            هزینه حیوانات</b-form-checkbox
          >
          <b-form-input
            lazy
            :formatter="formatnumber"
            :disabled="!ticketInput.prices.pricePerAnimal.hasPrice"
            v-model="ticketInput.prices.pricePerAnimal.price"
          ></b-form-input>
        </b-form-group>
        <b-col md="12" class="mt-2"></b-col>
        <b-col cols="6" md="6"> تخفیف به تعداد نفرات </b-col>
        <b-col cols="6" md="6" class="d-flex justify-content-end">
          <b-form-group label-for="discount" class="col-md-6">
            <!-- @change="value2 = $events" -->
            <b-form-spinbutton
              name="discount"
              id="sb-input"
              v-model="discounts"
              size="sm"
              min="0"
              max="10"
              @input="removeDiscountBtnIsClicked = false,clickOnDiscountSpinBtn=true"
            ></b-form-spinbutton>
          </b-form-group>
        </b-col>

        <b-col
          md="12"
          v-for="(item, index) in ticketInput.prices_off"
          :key="'off_' + index"
        >
          <b-row>
            <b-form-group class="mt-1 col-6 col-sm-3">
              <label for="name" class="text-capitalize">از : </label>
              <b-input-group append="نفر">
                <b-form-input v-model.number="item.from" type="number" />
              </b-input-group>
            </b-form-group>

            <b-form-group class="mt-1 col-6 col-sm-3">
              <label for="name" class="text-capitalize">تا : </label>
              <b-input-group append="نفر">
                <b-form-input v-model.number="item.to" type="number" />
              </b-input-group>
            </b-form-group>

            <b-form-group class="mt-1 col-6 col-sm-3">
              <label for="name" class="text-capitalize">تخفیف : </label>
              <b-form-input v-model.number="item.discount" type="number" />
            </b-form-group>
            <b-form-group class="mt-1 col-4 col-sm-2">
              <label for="name" class="text-capitalize">به صورت : </label>
              <b-form-input disabled type="text" value="درصدی" />
            </b-form-group>
            <b-button
              @click="removeDiscount(index)"
              variant="flat-danger"
              class="font-weight-bolder col-1 col-sm-1"
            >
              <feather-icon icon="Trash2Icon" size="20" />
            </b-button>
          </b-row>
        </b-col>

        <b-col md="12" class="mt-2"> </b-col>
        <b-col md="12" class="mt-2"></b-col>
        <b-col cols="6" md="6"> خدمات ویژه </b-col>
        <b-col cols="6" md="6" class="d-flex justify-content-end">
          <b-form-group label-for="discount" class="col-md-6">
            <!-- @change="value2 = $events" -->
            <b-form-spinbutton
              name="discount"
              id="sb-input"
              v-model="services"
              size="sm"
              min="0"
              max="10"
              @input="removeServicesBtnIsClicked = false,clickOnServiceSpinBtn=true"
            ></b-form-spinbutton>
          </b-form-group>
        </b-col>

        <b-col
          md="12"
          v-for="(item, index) in ticketInput.special_services"
          :key="'service_' + index"
        >
          <b-row>
            <b-form-group class="mt-1 col-6 col-sm-3">
              <label for="name" class="text-capitalize">عنوان : </label>
              <b-form-input v-model="item.name" type="text" />
            </b-form-group>

            <b-form-group class="mt-1 col-6 col-sm-3">
              <label for="name" class="text-capitalize">هزینه : </label>
              <b-form-input v-model.number="item.price" type="number" />
            </b-form-group>

            <b-form-group
              class="col-6 mt-1 col-sm-3"
              label="شیوه ارائه"
              label-for="min-night-input"
            >
              <b-form-select
                v-model="item.method"
                :options="methodss"
                value-field="value"
                text-field="text"
              ></b-form-select>
            </b-form-group>
            <b-form-group class="mt-1 col-4 col-sm-2">
              <b-form-checkbox
                v-model="item.perPerson"
                :id="`perperson_${index}`"
                class="font-sm"
                ><small> به ازای هر نفر</small>
              </b-form-checkbox>
            </b-form-group>
            <b-button
              @click="removeService(index)"
              variant="flat-danger"
              class="font-weight-bolder col-1 col-sm-1"
            >
              <feather-icon icon="Trash2Icon" size="20" />
            </b-button>
          </b-row>
        </b-col>

        <b-form-group class="mt-1 col-md-12">
          <label for="description" class="text-capitalize"> توضیحات کوتاه و مختصر در مورد تیکت : </label>
          <b-form-input
              id="description"
              v-model="ticketInput.description"
              type="text"
              @input="removeErrors('description')"
          />
        </b-form-group>

        <b-form-group class="mt-1 col-md-12">
          <label for="name" class="text-capitalize">  کمیسیون دریافتی سایت به ازای هر فرد : </label>
          <b-form-input  v-model="ticketInput.commission_site" type="text" />
          <div v-if="ticketInput.commission_site>0">{{numberFormat(ticketInput.commission_site)}} تومان</div>
        </b-form-group>

        <b-form-group class="mt-1 col-md-12">
          <label for="name" class="text-capitalize">  کمیسیون میزبان : </label>
          <b-form-input  v-model="ticketInput.commission_host" type="text" />
          <div v-if="ticketInput.commission_host>0">{{numberFormat(ticketInput.commission_host)}} تومان</div>
        </b-form-group>

        <b-form-group class="mt-1 col-md-12" v-slot="{ ariaDescribedby }">
          <label for="province_status" class="text-capitalize"> وضعیت : </label>
          <b-form-checkbox
            v-model="ticketInput.status"
            :aria-describedby="ariaDescribedby"
            value="active"
            @input="removeErrors('status')"
            >فعال</b-form-checkbox
          >
          <b-form-checkbox
            v-model="ticketInput.status"
            :aria-describedby="ariaDescribedby"
            value="inactive"
            @input="removeErrors('status')"
            >پیش نویس</b-form-checkbox
          >
          <ErrorMessage
            errorType="status"
            :errorMessages="errorMessage"
          ></ErrorMessage>
        </b-form-group>
      </b-container>
      <template #footer>
        <div class="d-flex align-items-center justify-content-end px-2 py-1">
          <b-button
            class="text-capitalize mr-2"
            @click="formModal = false"
            variant="outline-dark"
          >
            {{ $t("cancel") }}
          </b-button>
          <b-button variant="primary" @click="submitForm()">
            <div v-if="submitLoading" class="px-1">
              <b-spinner small style="width: 1.3rem; height: 1.3rem" />
              <span class="sr-only">Loading...</span>
            </div>
            <span v-else class="text-capitalize">
              {{ $t("submit") }}
            </span>
          </b-button>
        </div>
      </template>
    </b-sidebar>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BCard,
  BAvatar,
  BButton,
  BSpinner,
  BSidebar,
  BContainer,
  BFormTextarea,
  BFormCheckbox,
  BTableSimple,
  BThead,
  BTbody,
  BFormSelect,
  BTr,
  BTh,
  BTd,
  BFormCheckboxGroup,
  BFormSpinbutton,
  BTime,
  BInputGroup, BBadge, BFormRadio,
} from "bootstrap-vue";
import PerPage from "@/components/PerPage.vue";
import Breadcrumb from "@/components/Breadcrumb.vue";
import Pagination from "@/components/Pagination.vue";
import Search from "@/components/Search.vue";
import TableHead from "@/components/TableHead.vue";
import vSelect from "vue-select";
import ErrorMessage from "@/components/ErrorMessage.vue";
import FilePicker from "@/components/FilePicker.vue";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";

export default {
  components: {
    BFormRadio,
    BBadge,
    BRow,
    BCol,
    PerPage,
    BFormGroup,
    BFormInput,
    BCard,
    BAvatar,
    BButton,
    BFormSelect,
    Breadcrumb,
    Pagination,
    Search,
    TableHead,
    BSpinner,
    BSidebar,
    BContainer,
    BFormTextarea,
    vSelect,
    ErrorMessage,
    BFormCheckbox,
    FilePicker,
    BTableSimple,
    BThead,
    BTbody,
    BTr,
    BTh,
    BTd,
    BFormCheckboxGroup,
    BFormSpinbutton,
    BTime,
    datePicker: VuePersianDatetimePicker,
    BInputGroup,
  },
  data() {
    return {

      dayOptions: [
        { text: 'شنبه', value: 'Saturday' },
        { text: 'یکشنبه', value: 'Sunday' },
        { text: 'دوشنبه', value: 'Monday' },
        { text: 'سه شنبه', value: 'Tuesday' },
        { text: 'چهارشنبه', value: 'Wednesday' },
        { text: 'پنجشنبه', value: 'Thursday' },
        { text: 'جمعه', value: 'Friday' },
      ],
      optionsShow: [
        { value: null, text: "انتخاب نمایش در ص اصلی" },
        { value: "0", text: "عدم نمایش در صفحه اصلی" },
        { value: "1", text: "نمایش در صفحه اصلی" },
      ],
      car: {},
      iconImageurl: "",
      errorMessage: {},
      perPage: 10,
      page: 1,
      buildings: [],
      carDates: [],
      defaultAvatar: require("@/assets/images/avatars/default.png"),
      cancelToken: undefined,
      sortBy: "",
      sortDir: "",
      searchInput: "",
      paginationData: null,
      tableHeadings: [
        {
          title: "تصویر آیکن",
          slug: "image_icon",
          sortable: false,
        },
        {
          title: "آیکن",
          slug: "icon",
          sortable: false,
        },
        {
          title: "عنوان",
          slug: "name",
          sortable: true,
        },
        {
          title: "توضیحات",
          slug: "description",
          sortable: true,
        },
        {
          title: "نمایش در صفحه",
          slug: "show_index_page",
          sortable: true,
        },
        {
          title: "تاریخ ایجاد",
          slug: "created_at",
          sortable: true,
        },

        {
          title: "وضعیت",
          slug: "status",
          sortable: false,
        },
        {
          title: "actions",
          sortable: false,
        },
      ],

      OpenIndicator: {
        render: (createElement) =>
          createElement("feather-icon", { attrs: { icon: "ChevronDownIcon" } }),
      },
      companies: [],
      buildingsCancelToken: undefined,
      ticketInput: {
        id: "",
        name: "",
        slug: "",
        description: "",
        max_people: "",
        max_capacity_people: "",
        price_type: "pricePerPerson",
        status: "",
        commission_site: "",
        commission_host: "",
        duration: "",

        image: null,
        icon: "",
        show_index_page: "",
        is_recurring_period: false,
        recurring_period: [],
        prices: {
          priceType: "pricePerKillometers",
          peack_days: null,
          normal_dayes: null,
          weekend_days: null,
          pricePerBaby: {
            name: "هزینه به ازای هر نوزاد",
            price: "",
            hasPrice: false,
          },
          pricePerAnimal: {
            name: "هزینه حیوانات",
            price: "",
            hasPrice: false,
          },
          start_date: null,
          end_date: null,
        },
        special_services: [],
        prices_off: [],
        execution_type: "",
        gender: "",
        ticket_type: "",
        start_date: null,
        return_date: null,
      },
      methodss: [
        { value: "daily", text: "روزانه" },
        { value: "oneTime", text: "یکبار" },
      ],
      editMode: false,
      formModal: false,
      submitLoading: false,
      discounts: 0,
      removeDiscountBtnIsClicked: false,
      services: 0,
      removeServicesBtnIsClicked: false,
      clickOnDiscountSpinBtn:false,
      clickOnServiceSpinBtn:false
    };
  },
  mounted() {
    this.$store.commit("verticalMenu/UPDATE_VERTICAL_MENU_COLLAPSED", false);
    this.getTickets();
    this.getBuildings();
    this.getExperience();
  },
  watch: {
    searchInput(value) {
      this.page = 1;
      this.getTickets();
    },
    perPage(value) {
      this.page = 1;
      this.getTickets();
    },
    page(value) {
      this.getTickets();
    },
    discounts(newVal, oldVal) {
      if (this.removeDiscountBtnIsClicked|| !this.clickOnDiscountSpinBtn) {
        this.clickOnDiscountSpinBtn=true
        return;
      }
      if (newVal == 0) {
        this.ticketInput.prices_off = [];
      } else if (newVal < oldVal) {
        this.ticketInput.prices_off.splice(-1);
      } else if (newVal > oldVal) {
        this.ticketInput.prices_off.push({ from: "", to: "", discount: 0 });
      }
    },
    services(newVal, oldVal) {
      if (this.removeServicesBtnIsClicked || !this.clickOnServiceSpinBtn) {
        this.clickOnServiceSpinBtn=true
        return;
      }
      if (newVal == 0) {
        this.ticketInput.special_services = [];
      } else if (newVal < oldVal) {
        this.ticketInput.special_services.splice(-1);
      } else if (newVal > oldVal) {
        this.ticketInput.special_services.push({
          name: "",
          price: "",
          method: 0,
          perPerson: false,
        });
      }
    },
  },
  methods: {
    numberFormat(number) {
      return  new Intl.NumberFormat().format(number)
    },
    inputIconImageFile(file) {
      this.removeErrors("image");
      this.ticketInput.image = file;
    },
    removeErrors(data) {
      if (
        typeof this.errorMessage[data] !== "undefined" &&
        this.errorMessage[data].length > 0
      ) {
        // this.errorMessage[data][0]="salllam"
        delete this.errorMessage[data];
        this.errorMessage = Object.assign(
          {},
          this.errorMessage,
          this.errorMessage
        );
        console.log(data, this.errorMessage);
      }
    },
    sort(args) {
      this.page = 1;
      this.sortBy = args.sortBy;
      this.sortDir = args.sortDir;
      this.getTickets();
    },

    async getTickets() {
      const requestData = {
        method: "get",
        url: "/admin/cars/car_dates/car/"+this.$route.params.id+'?paginate=true',
        // params: data,
        // cancelToken: this.cancelToken.token,
      };
      this.$http(requestData)
        .then((response) => {
          let data = response.data;
          this.carDates = data.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    showConfirmModal(carDate) {
      this.$bvModal
        .msgBoxConfirm(
          `آیا از حذف بلیط مطمئن هستید ؟  : ${carDate.name}.`,
          {
            title: this.$t("Please Confirm"),
            size: "sm",
            okVariant: "primary",
            okTitle: this.$t("Yes"),
            cancelTitle: this.$t("No"),
            cancelVariant: "outline-secondary",
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then(async (confirmed) => {
          if (confirmed) {
            let residenceIndex = 0;
            this.carDates = await this.carDates.filter(
              (residenceItem, index) => {
                if (residenceItem.id == carDate.id) {
                  residenceIndex = index;
                }
                return residenceItem.id !== carDate.id;
              }
            );

            const requestData = {
              method: "delete",
              url: `/admin/cars/car_dates/${carDate.id}`,
            };
            this.$http(requestData)
              .then((response) => {
                this.$bvToast.toast(
                  `بلیط: ${carDate.name}  با موفقیت حذف شد.`,
                  {
                    title: this.$t("Done"),
                    variant: "success",
                    solid: true,
                  }
                );
              })
              .catch((err) => {
                let message = this.$t("Unable to delete!");
                if (
                  err.response &&
                  err.response.data &&
                  err.response.data.message
                )
                  message = err.response.data.message;
                this.$bvToast.toast(message, {
                  title: this.$t("Error"),
                  variant: "danger",
                  solid: true,
                });
                this.carDates.splice(residenceIndex, 0, carDate);
              });
          }
        });
    },
    showFormModal(carDate) {
      console.log('****************************',carDate)
      this.clickOnDiscountSpinBtn=false
      this.clickOnServiceSpinBtn=false
      if (carDate) {
        (this.ticketInput = {
          id: carDate.id,
          name: carDate.name,
          status: carDate.status,
          is_recurring_period: carDate.is_recurring_period,
          recurring_period: carDate.recurring_period,
          prices: carDate.prices,
          prices_off: carDate.prices_off,
          special_services: carDate.special_services,
          execution_type: carDate.execution_type,
          gender: carDate.gender,
          max_people:carDate.max_people,
          max_capacity_people:carDate.max_capacity_people,
          description:carDate.description,
          price_type:carDate.price_type,
          commission_site:carDate.commission_site,
          commission_host:carDate.commission_host,
          duration:carDate.duration,
          ticket_type: carDate.ticket_type,
          start_time: carDate.start_time,
          end_time: carDate.end_time,
          start_date: carDate.start_date,
          return_date: carDate.return_date,
        }),
          (this.discounts = carDate.prices_off.length),
          (this.services = carDate.special_services.length),
          (this.editMode = true);
      } else {
        (this.discounts = 0),
          (this.services = 0),
          (this.ticketInput = {
            name: "",
            status: "",
            is_recurring_period: false,
            recurring_period: [],
            prices: {
              start_time: "",
              end_time: "",
              priceType: "pricePerKillometers",
              peack_days: null,
              normal_dayes: null,
              weekend_days: null,
              pricePerBaby: {
                name: "هزینه به ازای هر نوزاد",
                price: "",
                hasPrice: false,
              },
              pricePerAnimal: {
                name: "هزینه حیوانات",
                price: "",
                hasPrice: false,
              },
              start_date: null,
              end_date: null,
            },
            prices_off: [],
            special_services: [],
            execution_type: "",
            max_people:"",
            max_capacity_people:"",
            price_type:"",
            description:"",
            commission_site:"",
            commission_host:"",
            duration:"",
            gender: "",
            start_time:null,
            start_date: null,
            ticket_type: "",
          }),
          (this.editMode = false);
      }
      this.formModal = true;
    },
    submitForm() {
      if (this.submitLoading) return;
      let errorMessage = null;
      if (!errorMessage && !this.ticketInput.name) {
        errorMessage = "لطفا نام بلیط  را وارد کنید";
      }

      if (errorMessage) {
        this.$bvToast.toast(errorMessage, {
          title: this.$t("Error"),
          variant: "danger",
          solid: true,
        });
        return;
      }

      this.submitLoading = true;

      const requestData = {
        method: this.editMode ? "post" : "post",
        url: this.editMode
          ? `/admin/cars/car_dates/update/${this.ticketInput.id}`
          : `/admin/cars/car_dates`,
        data: { ...this.ticketInput, car_id: this.$route.params.id },
      };

      this.$http(requestData)
        .then((response) => {
          let message = " بلیط با موفقیت اضافه شد";
          if (this.editMode) message = " بلیط با موفقیت ویرایش شد";
          this.$bvToast.toast(message, {
            title: this.$t("Done"),
            variant: "success",
            solid: true,
          });

          this.submitLoading = false;
          this.formModal = false;
          this.getTickets();
        })
        .catch((err) => {
          let message = "خطا در ایجاد  بلیط";
          if (this.editMode) message = "خطا در ویرایش  بلیط";
          if (
            err.response &&
            err.response.data &&
            err.response.data.response &&
            err.response.data.response.message
          )
            message = err.response.data.response.message;
          if (
            err.response &&
            err.response.data &&
            err.response.data.response &&
            err.response.data.response.meta &&
            err.response.data.response.meta.errors
          )
            this.errorMessage = err.response.data.response.meta.errors;
          console.log("this.errorMessage", this.errorMessage);

          this.$bvToast.toast(message, {
            title: this.$t("Error"),
            variant: "danger",
          });
          this.submitLoading = false;
          console.log(err);
        });
    },
    getBuildings(search, loading) {
      if (typeof this.buildingsCancelToken != typeof undefined) {
        this.buildingsCancelToken.cancel(
          "Operation canceled due to new request."
        );
      }
      //Save the cancel token for the current request
      this.buildingsCancelToken = this.$http.CancelToken.source();

      let data = {
        search: search,
        per_page: 10,
        page: 1,
      };

      const requestData = {
        method: "get",
        url: "buildings",
        params: data,
        cancelToken: this.buildingsCancelToken.token,
      };
      this.$http(requestData)
        .then((response) => {
          let data = response.data.data;
          this.buildings = data.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getExperience() {
      const requestData = {
        method: "get",
        url: `/admin/cars/${this.$route.params.id}`,
      };
      this.$http(requestData)
        .then((response) => {
          let data = response.data;

          this.car = data.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    formatnumber(newValue) {
      const result = newValue
        .replace(/\D/g, "")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return result;
    },
    removeDiscount(index) {
      this.removeDiscountBtnIsClicked = true;
      this.ticketInput.prices_off.splice(index, 1);
      this.discounts = this.discounts - 1;
    },

    removeService(index) {
      this.removeServicesBtnIsClicked = true;
      this.ticketInput.special_services.splice(index, 1);
      this.services = this.services - 1;
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>